import { atom } from 'jotai';

export const selectedTab = atom('Forecast');

export const businessUnitsAtom = atom([]);

export const selectedBusinessUnitAtom = atom(null);

export const jobsAtom = atom(null);

export const liveForecast = atom('live');

export const selectedJobAtom = atom(null);

export const selectedJobDataAtom = atom({});

export const selectedTeamAtom = atom(null);

// Scope for the portfolio-wide procurement tabs (Uncommitted, Dates).
// { mode: 'job' | 'teams', job?: string, teams: string[] } — null until first
// render, when it seeds from the top-menu job/team. Shared so switching between
// the two tabs keeps the buyer's scope.
export const procurementScopeAtom = atom(null);

export const selectedVersionAtom = atom(null);

export const selectedWIPAtom = atom(null);

export const currentUserIdAtom = atom(null);

export const currentUserNameAtom = atom(null);

export const phasedProjectAtom = atom(false);

export const projectCompleteAtom = atom(false);

export const authStateAtom = atom({idToken: false});

export const jobDataAtom = atom(null);

export const jobOpenCommitmentsAtom = atom(null);

export const jobBillingsAtom = atom(null);

export const jobUserDataAtom = atom(null);

// Billing tab rows live outside the weekly forecast versions: invoices,
// billed lines, markups and time card states are facts about the job, not a
// forecast snapshot, and the SQL Agent version builds (several a day during a
// blitz) copy Forecast_User_Data forward at build start — anything saved to
// the "current" version after that copy was stranded on the old version and
// never seen again. All Billing reads and writes use this Version_GUID.
export const BILLING_VERSION = 0;
// The selected job's Billing rows at BILLING_VERSION (null until loaded).
export const billingUserDataAtom = atom(null);

export const jobCostDetailAtom = atom(null);

export const jobCostDetailCondensedAtom = atom(null);

export const jobHEETDataAtom = atom(null);

export const jobUserDetailAtom = atom(null);

export const percentLoadedAtom = atom(0);

export const dataSourceBillingsAtom = atom('');

export const dataSourceOpenCommitmentsAtom = atom('');

export const dataSourceCostDetailAtom = atom('');

export const k2DataAtom = atom(null);

export const dataSourceJobDataAtom = atom('');

export const dataSourceVersionAtom = atom('');

export const dataSourceJobsAtom = atom('');

export const dataSourceJobsClosedAtom = atom([]);

export const dataSourceJobsInventoryAtom = atom([]);

export const dataSourceTeamsAtom = atom([]);

export const dataSourceUserDetailsAtom = atom(null);

export const testJobsAtom = atom([]);

export const phasedForecastAtom = atom('regular');

export const dayZeroAtom = atom(true);

export const seenBeforeAtom = atom(false);

export const tokenAtom = atom('');

export const ohPercentAtom = atom(0);

export const ohPrevPercentAtom = atom(0);

export const budgetDeltaWipAtom = atom();

export const laborDeltaWipAtom = atom();

export const equipmentDeltaWipAtom = atom();

export const materialsDeltaWipAtom = atom();

export const subDeltaWipAtom = atom();

export const otherDeltaWipAtom = atom();

export const overheadDeltaWipAtom = atom();

export const mechanicallyCompleteAtom = atom(false);

export const startDateActualAtom = atom(null);

export const userEmailAtom = atom('');

export const jobUserAssignmentsAtom = atom([]);

export const equipmentCellUpdateAtom = atom(false);

export const jobPhaseCodesAtom = atom({});

export const isLiveVersionAtom = atom(true);

export const overheadDataAtom = atom({});

export const contBudgetPercentAtom = atom(0);

export const contPercentAtom = atom(0);

export const jobUserDataPrevAtom = atom(null);

export const jobOpenCommitmentsPrevAtom = atom(null);

export const jobBillingsPrevAtom = atom(null);

export const jobCostDetailPrevAtom = atom(null);

export const contingencyDeltaWipAtom = atom(0);

export const userNameAtom = atom('');

export const userIdAtom = atom('');

export const userEmailCheckAtom = atom('');

export const userIsGoodAtom = atom(true);

// Role from PC.Forecast_Users (e.g. 'Project Coordinator'); '' = standard user.
export const userRoleAtom = atom('');

// Admin-only "View as role" preview. When set, the app renders as if the current
// user had this role, so an admin can see restricted views (e.g. Project
// Coordinator) without a second login. '' = off (use the real role). Persisted to
// localStorage so it survives reloads; toggled from the switcher in the top menu.
export const previewRoleAtom = atom(
    (typeof localStorage !== 'undefined' && localStorage.getItem('previewRole')) || ''
);

export const selectedVersionLockedAtom = atom(false);

// Admin version unlocks, [{version, job, until, by}] — see db/versionUnlock.js.
export const versionUnlocksAtom = atom([]);

export const psrSlideSelectionsAtom = atom({});

export const equipmentRatesAtom = atom({});

export const equipmentDescriptionsAtom = atom({});

export const equipmentAssetsAtom = atom([]);

export const loadingCostAtom = atom(false);

export const projectManagerAtom = atom('');

export const actualHoursAtom = atom(0);

export const actualHoursTestAtom = atom(null);

export const budgetHoursAtom = atom(null);

export const budgetHoursTestAtom = atom(null);

export const updatedBudgetHoursAtom = atom(null);

export const updatedBudgetHoursTestAtom = atom(null);

export const eacHoursAtom = atom(null);

export const eacHoursTestAtom = atom(null);

export const jobLoadedAtom = atom(false);

// Dashboard cache atoms
export const dashboardTeamUserDataAtom = atom(null);
export const dashboardCostDetailDataAtom = atom(null);
export const dashboardOpenCommitmentsDataAtom = atom(null);
export const dashboardBillingsDataAtom = atom(null);
export const dashboardEarnedRevenueDataAtom = atom(null);
export const dashboardLaborHoursByWeekDataAtom = atom(null);
export const dashboardCacheKeyAtom = atom(null); // stores team+version to detect changes

// Variance history for line graph (stores variance data across multiple versions)
export const varianceHistoryAtom = atom([]);

// Side menu budget/cost atoms (shared with overview pages)
export const sideMenuBudgetsAtom = atom({
    contractValuesRevised: 0,
    changeOrderRevenue: 0,
    laborDayZeroBudget: 0,
    equipmentDayZeroBudget: 0,
    materialsDayZeroBudget: 0,
    subcontractorsDayZeroBudget: 0,
    otherExpensesDayZeroBudget: 0,
    contingencyDayZeroBudget: 0,
    overheadDayZeroBudget: 0,
    typeBudgets: {}
});
export const sideMenuCostsAtom = atom({
    contingency: 0,
    labor: 0,
    materials: 0,
    rentals: 0,
    subs: 0,
    other: 0,
    equipment: 0,
    overhead: 0,
    totalCost: 0
});

// CO Log validation chip (shared between cologEntryClassic and cologOverview)
export const coValidationChipsAtom = atom([]);

// Incentive calculation atoms (shared between bidForecast and other pages)
export const incentiveEligibleAtom = atom('-');
export const incentiveEligibleAmountAtom = atom('-');
export const incentiveCalcBreakdownAtom = atom('');
export const incentiveRateAtom = atom('25');